<ng-container *ngIf="palette !== null">
    <ng-container *ngIf="!palette.merged">
        <div class="mr-12 px-2 flex flex-col gap-2 min-w-16">
            <div class="flex flex-col ml-2">
                <div class="font-bold">
                    {{ palette.title }}
                </div>
                <div class="flex flex-col">
                    <ng-container *ngFor="let item of palette.data">
                        <div *ngIf="item.color" class="flex gap-2">
                            <div class="flex-none">
                                <span class="mdi mdi-circle text-xs" [style.color]="item.color"></span>
                            </div>
                            <div>
                                <span>{{ item.title }}</span>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="palette.merged">
        <div class="mr-12 px-2 flex flex-col gap-2 min-w-16">
            <div class="flex flex-col ml-2 gap-2">
                <ng-container *ngFor="let mergedPalette of palette.merged_data">
                    <div class="flex flex-col ml-2">
                        <div class="font-bold">
                            {{ mergedPalette.title }}
                        </div>
                        <div class="flex flex-col">
                            <ng-container *ngFor="let item of mergedPalette.data">
                                <div *ngIf="item.color" class="flex gap-2">
                                    <div class="flex-none">
                                        <span class="mdi mdi-circle text-xs" [style.color]="item.color"></span>
                                    </div>
                                    <div>
                                        <span>{{ item.title }}</span>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-container>
</ng-container>
<ng-container *ngIf="palette === null">
    <div class="w-full h-20 flex items-center justify-center">
        <mat-progress-spinner
            class="mat-progress-spinner-select_load"
            matSuffix
            color="primary"
            mode="indeterminate"
            diameter="24"
        >
        </mat-progress-spinner>
    </div>
</ng-container>
